import { StrictMode } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import Main from "./pages/main/main";
import Savior from "./pages/savior/savior";
import SaviorDetail from "./pages/savior/savior-detail";
import Arcana from "./pages/arcana/arcana";
import ArcanaDetail from "./pages/arcana/arcana-detail";
// import Deck from "./pages/deck/deck";
import Journey from "./pages/journey/journey";
import Schedule from "./pages/schedule/schedule";
import Gacha from "./pages/gacha/gacha";
import store from "./store/store";
import Item from "./pages/item/item";
// import Music from "./pages/music/music";
import SaviorSimulator from "./pages/savior-simulator/savior-simulator";
import Wallpaper from "./pages/wallpaper/wallpaper";
import Preview from "./pages/preview/preview";
import Monster from "./pages/monster/monster";
import Potential from "./pages/potential/potential";

export default function App() {
    return (
        <StrictMode>
            <Provider store={store}>
                <BrowserRouter basename={process.env.REACT_APP_LIVE_URL}>
                    <Routes>
                        <Route index element={<Main />} />

                        <Route path="/savior" element={<Savior />} />
                        <Route path="/savior/:id" element={<SaviorDetail />} />
                        <Route path="/arcana" element={<Arcana />} />
                        <Route path="/arcana/:id" element={<ArcanaDetail />} />
                        {/* <Route path="/deck" element={<Deck />} /> */}
                        <Route path="/journey" element={<Journey />} />
                        <Route path="/schedule" element={<Schedule />} />
                        <Route path="/gacha" element={<Gacha />} />
                        <Route path="/item" element={<Item />} />
                        <Route path="/monster" element={<Monster />} />
                        <Route path="/potential" element={<Potential />} />
                        {/* <Route path="/music" element={<Music />} /> */}
                        <Route path="/wallpaper" element={<Wallpaper />} />
                        <Route path="/simulator/savior" element={<SaviorSimulator />} />
                    </Routes>
                </BrowserRouter>
            </Provider>
        </StrictMode>
    );
}
